import { Grid, Typography } from "@material-ui/core";
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { alpha, makeStyles, withStyles, Theme, createStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem, { TreeItemProps } from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import { TransitionProps } from '@material-ui/core/transitions';
import { client } from "../dataProvider";
import { useEffect, useState } from "react";


function MinusSquare(props: SvgIconProps) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 20, height: 20 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path
                d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
        </SvgIcon>
    );
}

function PlusSquare(props: SvgIconProps) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 20, height: 20 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path
                d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
        </SvgIcon>
    );
}

function CloseSquare(props: SvgIconProps) {
    return (
        <SvgIcon className="close" fontSize="inherit" style={{ width: 20, height: 20 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path
                d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
        </SvgIcon>
    );
}

function TransitionComponent(props: TransitionProps) {

    return (
        <div>
            <Collapse {...props} />
        </div>
    );
}


const StyledTreeItem = withStyles((theme: Theme) =>
    createStyles({
        iconContainer: {
            '& .close': {
                opacity: 0.3,
            },
        },
        group: {
            marginLeft: 20,
            paddingLeft: 40,
            borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
        },
        label: {
            fontSize: "1.2em",
            fontWeight: "bold"
        }
    }),
)((props: TreeItemProps) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

const useStyles = makeStyles(
    createStyles({
        root: {
            height: "80%",
            flexGrow: 1,
            maxWidth: "80%",
        },
    }),
);


export const PermissionInfoPage = (props: any) => {

    const [usersGroupped, setUsersGroupped] = useState<any>([]);
    const [groupsUser, setGroupsUser] = useState<any>([]);

    useEffect(() => {
        client("get_users_groupped", { method: "GET" }).then((res: any) => {
            setUsersGroupped(res.groups)
            setGroupsUser(res.users)
        });
    }, [])


    const { permissions } = props;

    const classes = useStyles();


    function getPermissionFromCode(code: string) {
        let p = permission_info.find((permission) => permission.code === code);
        return p ? p.title : "Permesso non trovato";
    }

    function getTitoleFromGroupCode(code: string) {
        let g = groups_info.find((group) => group.code === code);
        return g ? g.title : "Gruppo non trovato";
    }

    function groupPermissionForMain() {
        let tempGrouppedPermisison: any = {};
        for (let permission of permission_info) {
            if (!tempGrouppedPermisison[permission.main]) {
                tempGrouppedPermisison[permission.main] = [];
            }
            tempGrouppedPermisison[permission.main].push(permission);
        }
        let grouppedPermisison = [];
        for (let group in tempGrouppedPermisison) {
            grouppedPermisison.push({ group: group, permissions: tempGrouppedPermisison[group] });
        }
        return grouppedPermisison;
    }

    function groupPermissionForMainSelected(permissions: [string]) {
        let tempGrouppedPermisison: any = {};
        for (let permission of permission_info) {
            if (permissions.includes(permission.code)) {
                if (!tempGrouppedPermisison[permission.main]) {
                    tempGrouppedPermisison[permission.main] = [];
                }
                tempGrouppedPermisison[permission.main].push(permission);
            }
        }
        let grouppedPermisison = [];
        for (let group in tempGrouppedPermisison) {
            grouppedPermisison.push({ group: group, permissions: tempGrouppedPermisison[group] });
        }
        return grouppedPermisison;
    }


    const permission_info = [
        {
            main: "Anagrafiche",
            code: "employees.view_employee",
            title: "Visualizzare dipendenti",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "employees.change_employee",
            title: "Modificare dipendenti",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "distribution.view_driver",
            title: "Visualizzare autisti ",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "fleet_management.view_vehicle",
            title: "Visualizzare veicoli",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "distribution.view_vehicle",
            title: "Visualizzare veicoli (generale)",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "fleet_management.change_vehicle",
            title: "Modificare veicoli",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "registry.view_site",
            title: "Visualizzare sedi logistiche",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "registry.change_site",
            title: "Modificare sedi logistiche",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "registry.view_referrer",
            title: "Visualizzare soggetti di riferimento",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "registry.change_referrer",
            title: "Visualizzare e modificare soggetti di riferimento",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "registry.view_subjectattachment",
            title: "Visualizzare note di capitolato nei soggetti",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "registry.change_specificationnote",
            title: "Visualizzare e modificare note di capitolato nei soggetti",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "registry.view_specificationnote",
            title: "Visualizzare allegati nei soggetti",
            message: ""
        },
        {
            main: "Anagrafiche",
            code: "registry.change_subjectattachment",
            title: "Visualizzare e modificare allegati nei soggetti",
            message: ""
        },



        {
            main: "Bolle",
            code: "distribution.view_note",
            title: "Visualizzare bolle missioni",
            message: ""
        },
        {
            main: "Bolle",
            code: "distribution.change_note",
            title: "Modifcare e caricare bolle missioni",
            message: ""
        },
        {
            main: "Bolle",
            code: "distribution.delete_note",
            title: "Eliminare bolle missioni",
            message: ""
        },


        {
            main: "Contrassegni",
            code: "cash_on_delivery.view_cachet",
            title: "Visualizzare i contrassegni",
            message: ""
        },
        {
            main: "Contrassegni",
            code: "cash_on_delivery.change_cachet",
            title: "Gestire e modifcare i contrassegni",
            message: ""
        },
        {
            main: "Contrassegni",
            code: "cash_on_delivery.display_cachet_cashed",
            title: "Visualizzare e modifcare i contrassegni incassati",
            message: ""
        },
        {
            main: "Contrassegni",
            code: "cash_on_delivery.display_cachet_to_cash_in",
            title: "Visualizzare e modifcare i contrassegni da incassare",
            message: ""
        },
        {
            main: "Contrassegni",
            code: "cash_on_delivery.view_remittance",
            title: "Visualizzare rimesse",
            message: ""
        },
        {
            main: "Contrassegni",
            code: "distribution.change_remittance",
            title: "Gestire e modifcare rimesse",
            message: ""
        },
        {
            main: "Contrassegni",
            code: "cash_on_delivery.view_cachetbox",
            title: "Visualizzare casse contrassegni",
            message: ""
        },
        {
            main: "Contrassegni",
            code: "cash_on_delivery.change_cachetbox",
            title: "Gestire e modifcare casse contrassegni",
            message: ""
        },
        {
            main: "Contrassegni",
            code: "cash_on_delivery.view_cachetpayment",
            title: "Visualizzare incassi contrassegni",
            message: ""
        },
        {
            main: "Contrassegni",
            code: "cash_on_delivery.change_cachetpayment",
            title: "Gestire e modifcare incassi contrassegni",
            message: ""
        },


        {
            main: "Fatturazione",
            code: "distribution.view_category",
            title: "Visualizzare categorie articoli",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "distribution.change_category",
            title: "Modifcare categorie articoli",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "distribution.view_item",
            title: "Visualizzare articoli",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "distribution.change_item",
            title: "Modifcare articoli",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "distribution.view_tariff",
            title: "Visualizzare tariffe",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "distribution.change_tariff",
            title: "Modifcare tariffe",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "distribution.view_subtariff",
            title: "Visualizzare sotto tariffe",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "distribution.change_subtariff",
            title: "Modificare sotto tariffe",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.view_charge",
            title: "Visualizzare addebiti/valida righe fattura",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.change_charge",
            title: "Modifcare addebiti/valida righe fattura",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.view_invoice",
            title: "Visualizzare fattura, riba e import xml",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.change_invoice",
            title: "Modifcare fattura, riba e import xml",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.view_invoiceline",
            title: "Visualizzare le righe fattura",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.change_invoiceline",
            title: "Modifcare fattura le righe fattura",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.view_invoicepaymentstatus",
            title: "Visualizzare scadenzario e stati pagamento fatture",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.change_invoicepaymentstatus",
            title: "Modifcare scadenzario e stati pagamento fatture",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.view_chartaccounts",
            title: "Visualizzare categorie piano dei conti",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.change_chartaccounts",
            title: "Modifcare categorie piano dei conti",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.view_chartaccountstag",
            title: "Visualizzare tags piano dei conti",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.change_chartaccountstag",
            title: "Modifcare tags piano dei conti",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.view_invoicechartaccounts",
            title: "Visualizzare info piano dei conti",
            message: ""
        },
        {
            main: "Fatturazione",
            code: "accounting.change_invoicechartaccounts",
            title: "Modifcare/associare info piano dei conti",
            message: ""
        },


        {
            main: "Generale",
            code: "general",
            title: "Login nel sistema e visualizzazione homepage con funzioni base",
            message: ""
        },
        {
            main: "Generale",
            code: "base.autocomplete_general_view",
            title: "Campi generici con autocompletamento (Es. province, regioni,..)",
            message: ""
        },
        {
            main: "Generale",
            code: "base.autocomplete_customer_view",
            title: "Campi con autocompletamento specifici per i clienti (Es. province, soggetti clienti, ecc",
            message: ""
        },
        {
            main: "Generale",
            code: "base.view_accounting_s",
            title: "Per la fatturazzione attiva",
        },

        {
            main: "Generale",
            code: "base.view_accounting_p",
            title: "Per la fatturazzione passiva",
        },

        {
            main: "Generale",
            code: "base.view_accounting",
            title: "Per la fatturazzione generale",
        },

        {
            main: "Generale",
            code: "base.show_mission_revenues",
            title: "Visualizzazione dei ricavi delle missioni",
        },
        {
            main: "Generale",
            code: "base.show_business_intelligence",
            title: "Visualizzazione modulo BI",
        },


        {
            main: "Giri",
            code: "route_management.view_route",
            title: "Visualizzare giri e bacheca giri con i dettagli",
            message: ""
        },
        {
            main: "Giri",
            code: "route_management.change_route",
            title: "Modifcare giri e bacheca giri con i dettagli",
            message: ""
        },
        {
            main: "Giri",
            code: "route_management.delete_route",
            title: "Eliminare giri",
            message: ""
        },
        {
            main: "Giri",
            code: "distribution.view_route",
            title: "Visualizzare giri e bacheca giri con i dettagli (in relazione alle missioni, es pianificatore)",
            message: ""
        },
        {
            main: "Giri",
            code: "distribution.change_route",
            title: "Modifcare giri e bacheca giri con i dettagli (in relazione alle missioni, es pianificatore)",
            message: ""
        },
        {
            main: "Giri",
            code: "distribution.view_deliveryzone",
            title: "Visualizzare zone giri",
            message: ""
        },
        {
            main: "Giri",
            code: "distribution.change_deliveryzone",
            title: "Modificare zone giri",
            message: ""
        },
        {
            main: "Giri",
            code: "distribution.view_splitsegment",
            title: "Visualizzare split giri effettuati",
            message: ""
        },
        {
            main: "Giri",
            code: "distribution.change_splitsegment",
            title: "Modificare split giri effettuati",
            message: ""
        },

        {
            main: "Importazione file",
            code: "file_import.view_importedfile",
            title: "Visualizzare file importati e caricati (upload)",
            message: ""
        },
        {
            main: "Importazione file",
            code: "file_import.change_importedfile",
            title: "Modificare file importati e caricati (upload)",
            message: ""
        },
        {
            main: "Importazione file",
            code: "file_import.delete_importedfile",
            title: "Cancellare file importati e caricati (upload)",
            message: ""
        },
        {
            main: "Importazione file",
            code: "file_import.view_missingsubject",
            title: "Visualizzare i soggetti",
            message: ""
        },
        {
            main: "Importazione file",
            code: "file_import.change_missingsubject",
            title: "Risolvere i soggetti",
            message: ""
        },


        {
            main: "Log",
            code: "distribution.view_historicaldelivery",
            title: "Visualizzare log missioni",
            message: ""
        },
        {
            main: "Log",
            code: "registry.view_historicalsubject",
            title: "Visualizzare log soggetti",
            message: ""
        },
        {
            main: "Log",
            code: "cash_on_delivery.view_historicalcachet",
            title: "Visualizzare log contrassegni",
            message: ""
        },
        {
            main: "Log",
            code: "distribution.view_historicaldeliveryitem",
            title: "Visualizzare log servizi",
            message: ""
        },
        {
            main: "Log",
            code: "accounting.view_historicalcharge",
            title: "Visualizzare log addebiti",
            message: ""
        },

        {
            main: "Missioni",
            code: "distribution.view_delivery",
            title: "Visualizzare missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.change_delivery",
            title: "Modificare missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.view_segment",
            title: "Visualizzare tratte missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.change_segment",
            title: "Modificare tratte missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.view_deliverystatus",
            title: "Visualizzare stati missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.change_deliverystatus",
            title: "Modificare stati missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.delete_deliverystatus",
            title: "Eliminare stati missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.view_reasonstatus",
            title: "Visualizzare ragioni stati missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.change_reasonstatus",
            title: "Modificare ragioni stati missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "base.view_delivery",
            title: "Visualizzare bacheca monitor giri",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.view_deliveryitem",
            title: "Visualizzazzare servizi missioni più info ricavo singola consegna",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.change_deliveryitem",
            title: "Inseriere, modificare e visualizzazzare servizi missioni più info ricavo singola consegna",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.delete_deliveryitem",
            title: "Eliminare servizi missioni più info ricavo singola consegna",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.view_deliveryattachment",
            title: "Visualizzazzare allegati missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.change_deliveryattachment",
            title: "Inseriere, modificare e visualizzazzare allegati missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.view_deliverynoterow",
            title: "Visualizzazzare righe note missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.change_deliverynoterow",
            title: "Inseriere, modificare e visualizzazzare righe note missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.view_specificationnote",
            title: "Visualizzazzare note di capitolato",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.change_specificationnote",
            title: "Inseriere, modificare e visualizzazzare note di capitolato",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.view_deliverygroup",
            title: "Visualizzazzare ragguppamenti missioni",
            message: ""
        },
        {
            main: "Missioni",
            code: "distribution.change_deliverygroup",
            title: "Inseriere, modificare e visualizzazzare ragguppamenti missioni",
            message: ""
        },


        {
            main: "Portale clienti",
            code: "customers.add_customersubject",
            title: "Inserire soggetti portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.view_customersubject",
            title: "Visualizzare soggetti portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.change_customersubject",
            title: "Modifcare soggetti portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.delete_customersubject",
            title: "Eliminare soggetti portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.view_customerorder",
            title: "Visualizzare ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.add_customerorder",
            title: "Inserire ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.change_customerorder",
            title: "Modifcare ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.delete_customerorder",
            title: "Eliminare ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.add_customerorderitem",
            title: "Aggiungere servizi ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.view_customerorderitem",
            title: "Visualizzare servizi ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.change_customerorderitem",
            title: "Modifcare servizi ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.delete_customerorderitem",
            title: "Eliminare servizi ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.add_customernote",
            title: "Aggiungere bolle agli ordini nel portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.view_customernote",
            title: "Visualizzare bolle negli ordini del portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.change_customernote",
            title: "Modifcare bolle negli ordini del portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.delete_customernote",
            title: "Cancellare bolle negli ordini del portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.view_customerimportfile",
            title: "Visualizzare import file ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.change_customerimportfile",
            title: "Modifcare import file ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "customers.delete_customerimportfile",
            title: "Eliminare import file ordini portale clienti",
            message: ""
        },
        {
            main: "Portale clienti",
            code: "base.view_deliverytracking",
            title: "Visualizzare tracking portale clienti",
            message: ""
        },

        {
            main: "Portale vettori",
            code: "base.view_carrierdelivery",
            title: "Visualizzare ordini portale vettori",
            message: ""
        },
        {
            main: "Portale vettori",
            code: "base.change_carrierdelivery",
            title: "Modifcare ordini portale vettori",
            message: ""
        },
        {
            main: "Portale vettori",
            code: "carriers.view_carriernote",
            title: "Visualizzare e stampare bolle nel portale vettori",
            message: ""
        },
        {
            main: "Portale vettori",
            code: "carriers.view_carriercashbox",
            title: "Visualizzare e modifcare casse vettori",
            message: ""
        },



        {
            main: "Risorse umane",
            code: "employees.change_presencezone",
            title: "Visualizzare e modifica zone badge presenze",
            message: ""
        },
        {
            main: "Risorse umane",
            code: "employees.view_workpermit",
            title: "Visualizzare propri permessi ",
            message: ""
        },
        {
            main: "Risorse umane",
            code: "employees.change_workpermit",
            title: "Visualizzare e modificare propri permessi ",
            message: ""
        },
        {
            main: "Risorse umane",
            code: "employees.change_workpermit",
            title: "Visualizzare e badgare propri presenze ",
            message: ""
        },


        {
            main: "Soggetti",
            code: "registry.view_subject",
            title: "Visualizzare soggetti",
            message: ""
        },
        {
            main: "Soggetti",
            code: "registry.change_subject",
            title: "Modificare soggetti",
            message: ""
        },


        {
            main: "Utenti",
            code: "auth.view_user",
            title: "Visualizzare utenti con acceso al sistema (clienti e vettori)",
            message: ""
        },
        {
            main: "Utenti",
            code: "auth.change_user",
            title: "Modifcare utenti con acceso al sistema (clienti e vettori)",
            message: ""
        },

        {
            main: "Permessi",
            code: "base.change_workpermit_c1",
            title: "Modifcare permessi e regole permessi, più check convalida livello 1",
            message: ""
        },
        {
            main: "Permessi",
            code: "base.change_workpermit_c2",
            title: "Modifcare permessi e regole permessi, più check convalida livello 2",
            message: ""
        },
        {
            main: "Permessi",
            code: "base.change_workpermit_c3",
            title: "Modifcare permessi e regole permessi, più check convalida livello 3",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.view_workpermit",
            title: "Visualizzare permessi",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.change_workpermit",
            title: "Modifica permessi",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.view_workpermitrule",
            title: "Visualizza regole permessi",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.change_workpermitrule",
            title: "Modifica regole permessi",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.view_badge",
            title: "Visualizza badge",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.change_badge",
            title: "Modifica badge",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.view_presence",
            title: "Visualizza presenze",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.change_presence",
            title: "Modifica presenze",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.view_presenceqr",
            title: "Visualizza presenze qr",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.change_presenceqr",
            title: "Modifica presenze qr",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.view_presencezone",
            title: "Visualizza zone presenze",
            message: ""
        },
        {
            main: "Permessi",
            code: "employees.change_presencezone",
            title: "Modifica zone presenze",
            message: ""
        },

    ];

    const groups_info = [
        {
            code: "admin",
            title: "admin -> Admin",
            message: "",
            permissions: [
                "general"
            ]
        },

        {
            code: "driver",
            title: "driver -> Autista",
            message: "",
            permissions: [
                "general",
                "distribution.change_note",
            ]
        },

        {
            code: "client",
            title: "client -> Cliente",
            message: "",
            permissions: [
                "general",
                "customers.add_customernote",
                "customers.change_customerimportfile",
                "customers.view_customersubject",
                "customers.add_customerorder",
                "customers.delete_customersubject",
                "base.autocomplete_customer_view",
                "customers.change_customerorder",
                "customers.delete_customerorder",
                "customers.view_customerorder",
                "customers.change_customersubject",
                "customers.view_customerimportfile",
                "customers.add_customersubject",
                "customers.add_customerorderitem",
                "customers.view_customerorderitem",
                "customers.change_customerorderitem",
                "distribution.view_subtariff",
                "distribution.change_subtariff",
            ]
        },
        {
            code: "client_tracking",
            title: "client_tracking -> Cliente-Tracking",
            message: "",
            permissions: [
                "general",
                "base.view_deliverytracking",
            ]
        },

        {
            code: "cachet",
            title: "cachet -> Contrassegni",
            message: "",
            permissions: [
                "general",
                "base.autocomplete_general_view",
                "cash_on_delivery.display_cachet_to_cash_in",
                "cash_on_delivery.display_cachet_cashed",
                "cash_on_delivery.view_cachet",
                "cash_on_delivery.change_cachet",
                "cash_on_delivery.view_cachetpayment",
                "cash_on_delivery.view_cachetbox",
            ]
        },

        {
            code: "dashboard",
            title: "dashboard -> Dashboard",
            message: "",
            permissions: [
                "general",
                "base.autocomplete_general_view",
                "route_management.view_route",
                "route_management.change_route",
                "distribution.view_driver",
                "distribution.view_route",
                "distribution.change_route",
                "distribution.view_vehicle",
            ]
        },

        {
            code: "desk",
            title: "desk -> Desk",
            message: "",
            permissions: [
                "general"
            ]
        },

        {
            code: "warehouse",
            title: "warehouse -> Magazziniere",
            message: "",
            permissions: [
                "general",
                "base.autocomplete_general_view",
                "registry.view_subject",
                "distribution.view_delivery",
                "distribution.view_deliveryattachment",
                "distribution.view_deliverynoterow",
                "distribution.view_deliverystatus",
                "distribution.change_deliverystatus",
                "distribution.view_driver",
                "distribution.view_note",
                "distribution.change_note",
                "distribution.view_reasonstatus",
                "distribution.change_reasonstatus",
                "distribution.view_route",
                "distribution.view_segment",
                "distribution.change_segment",
                "distribution.view_vehicle",
                "route_management.view_route",
                "route_management.change_route",
                "distribution.change_deliverygroup",
                "distribution.view_deliverygroup",
            ]
        },
        {
            code: "warehouse_admin",
            title: "warehouse_admin -> Magazziniere Admin",
            message: "",
            permissions: [
                "general",
                "base.autocomplete_general_view",
                "registry.view_subject",
                "registry.change_subject",
                "registry.view_referrer",
                "registry.change_referrer",
                "registry.view_site",
                "registry.view_specificationnote",
                "registry.change_specificationnote",
                "distribution.view_delivery",
                "distribution.view_deliveryattachment",
                "distribution.change_deliveryattachment",
                "distribution.view_deliverynoterow",
                "distribution.change_deliverynoterow",
                "distribution.view_deliverystatus",
                "distribution.change_deliverystatus",
                "distribution.delete_deliverystatus",
                "distribution.view_deliveryzone",
                "distribution.view_deliveryitem",
                "distribution.change_deliveryitem",
                "distribution.delete_deliveryitem",
                "distribution.view_driver",
                "employees.view_employee",
                "distribution.view_note",
                "distribution.change_note",
                "distribution.delete_note",
                "distribution.view_reasonstatus",
                "distribution.change_reasonstatus",
                "distribution.view_route",
                "distribution.change_route",
                "distribution.view_delivery",
                "distribution.change_delivery",
                "distribution.view_segment",
                "distribution.change_segment",
                "distribution.view_vehicle",
                "fleet_management.view_vehicle",
                "route_management.view_route",
                "route_management.change_route",
                "distribution.view_tariff",
                "distribution.view_subtariff",
                "file_import.view_missingsubject",
                "file_import.view_importedfile",
                "file_import.change_importedfile",
                "distribution.view_subtariff",
                "distribution.change_deliverygroup",
                "distribution.view_deliverygroup",
            ]
        },

        {
            code: "planner",
            title: "planner -> Pianificatore",
            message: "",
            permissions: [
                "general",
            ]
        },

        {
            code: "scanner",
            title: "scanner -> Scanner",
            message: "",
            permissions: [
                "general",
            ]
        },

        {
            code: "trackme",
            title: "trackme -> TrackMe",
            message: "",
            permissions: [
                "general",
                "registry.view_subject",
                "registry.change_subject",
                "distribution.view_deliverystatus",
                "distribution.change_deliverystatus",
            ]
        },

        {
            code: "carrier",
            title: "carrier -> Vettore",
            message: "",
            permissions: [
                "general",
                "base.view_carrierdelivery",
                "carriers.view_carriernote",
                "carriers.view_carriercashbox",
                "distribution.view_reasonstatus",
                "distribution.change_note",
            ]
        },

        {
            code: "permission_1",
            title: "permission_1 -> Permessi Check 1",
            message: "",
            permissions: [
                "general",
                "base.autocomplete_general_view",
                "base.change_workpermit_c1",
                "employees.view_workpermit",
                "employees.change_workpermit",
                "employees.view_workpermitrule",
                "employees.change_workpermitrule",
            ]
        },

        {
            code: "permission_2",
            title: "permission_2 -> Permessi Check 2",
            message: "",
            permissions: [
                "general",
                "base.autocomplete_general_view",
                "base.change_workpermit_c2",
                "employees.view_workpermit",
                "employees.change_workpermit",
                "employees.view_workpermitrule",
                "employees.change_workpermitrule",
            ]
        },

        {
            code: "permission_3",
            title: "permission_3 -> Permessi Check 3",
            message: "",
            permissions: [
                "general",
                "base.autocomplete_general_view",
                "base.change_workpermit_c3",
                "employees.view_workpermit",
                "employees.change_workpermit",
                "employees.view_workpermitrule",
                "employees.change_workpermitrule",
            ]
        },

        {
            code: "employee_hr",
            title: "employee_hr -> Gestione Risorse Umane",
            message: "",
            permissions: [
                "general",
                "base.autocomplete_general_view",
                "employees.change_badge",
                "employees.view_badge",
                "employees.change_employee",
                "employees.view_employee",
                "employees.view_presence",
                "employees.change_presence",
                "employees.view_presenceqr",
                "employees.change_presenceqr",
                "employees.view_presencezone",
                "employees.change_presencezone"
            ]
        },

        {
            code: "user",
            title: "user -> Utenti",
            message: "",
            permissions: [
                "auth.change_user",
            ]
        },
        {
            code: "show_mission_revenues",
            title: "show_mission_revenues -> Visualizza ricavi missioni",
            message: "",
            permissions: [
                "base.show_mission_revenues",
            ]
        },
        {
            code: "business_intelligence",
            title: "business_intelligence -> Visualizza modulo BI",
            message: "",
            permissions: [
                "base.show_business_intelligence",
            ]
        },
        {
            code: "accounting_s",
            title: "accounting_s -> Fatturazione Attiva",
            message: "",
            permissions: [
                "base.view_accounting_s",
                "base.autocomplete_general_view",
                "accounting.change_charge",
                "accounting.view_charge",
                "accounting.change_termspayment",
                "accounting.view_termspayment",
                "accounting.change_charge",
                "accounting.view_invoice",
                "accounting.change_invoice",
                "accounting.view_invoiceline",
                "accounting.change_invoiceline",
                "accounting.view_invoicepaymentstatus",
                "accounting.change_invoicepaymentstatus",
                "accounting.view_chartaccounts",
                "accounting.change_chartaccounts",
                "accounting.view_chartaccountstag",
                "accounting.change_chartaccountstag",
                "accounting.view_invoicechartaccounts",
                "accounting.change_invoicechartaccounts",
                "distribution.view_category",
                "distribution.view_item",
                "distribution.view_tariff",
                "distribution.change_reasonstatus",
            ]
        },
        {
            code: "accounting_p",
            title: "accounting_p -> Fatturazione Passiva",
            message: "",
            permissions: [
                "base.view_accounting_p",
                "base.autocomplete_general_view",
                "accounting.change_charge",
                "accounting.view_charge",
                "accounting.change_termspayment",
                "accounting.view_termspayment",
                "accounting.change_charge",
                "accounting.view_invoice",
                "accounting.change_invoice",
                "accounting.view_invoiceline",
                "accounting.change_invoiceline",
                "accounting.view_invoicepaymentstatus",
                "accounting.change_invoicepaymentstatus",
                "accounting.view_chartaccounts",
                "accounting.change_chartaccounts",
                "accounting.view_chartaccountstag",
                "accounting.change_chartaccountstag",
                "accounting.view_invoicechartaccounts",
                "accounting.change_invoicechartaccounts",
                "distribution.view_category",
                "distribution.view_item",
                "distribution.view_tariff",
                "distribution.change_reasonstatus",
            ]
        },
        {
            code: "accounting",
            title: "accounting -> Fatturazione",
            message: "",
            permissions: [
                "base.view_accounting_s",
                "base.view_accounting_p",
                "base.autocomplete_general_view",
                "accounting.change_charge",
                "accounting.view_charge",
                "accounting.change_termspayment",
                "accounting.view_termspayment",
                "accounting.change_charge",
                "accounting.view_invoice",
                "accounting.change_invoice",
                "accounting.view_invoiceline",
                "accounting.change_invoiceline",
                "accounting.view_invoicepaymentstatus",
                "accounting.change_invoicepaymentstatus",
                "accounting.view_chartaccounts",
                "accounting.change_chartaccounts",
                "accounting.view_chartaccountstag",
                "accounting.change_chartaccountstag",
                "accounting.view_invoicechartaccounts",
                "accounting.change_invoicechartaccounts",
                'accounting.view_paymentschedule',
                'accounting.change_paymentschedule',
                'accounting.view_paymentschedulestatus',
                'accounting.change_paymentschedulestatus',
                'accounting.view_bankreceipt',
                'accounting.change_bankreceipt',
                "distribution.view_category",
                "distribution.view_item",
                "distribution.view_tariff",
                "distribution.change_reasonstatus",
            ]
        },
        {
            code: "reconciliation",
            title: "reconciliation -> Riconciliazione",
            message: "",
            permissions: [
                "base.autocomplete_general_view",
                "accounting.change_charge",
                "accounting.view_charge",
                "accounting.change_termspayment",
                "accounting.view_termspayment",
                "accounting.change_charge",
                "accounting.view_invoice",
                "accounting.change_invoice",
                "accounting.view_invoiceline",
                "accounting.change_invoiceline",
                "accounting.view_invoicepaymentstatus",
                "accounting.change_invoicepaymentstatus",
                "accounting.view_chartaccounts",
                "accounting.change_chartaccounts",
                "accounting.view_chartaccountstag",
                "accounting.change_chartaccountstag",
                "accounting.view_invoicechartaccounts",
                "accounting.change_invoicechartaccounts",
                'accounting.view_paymentschedule',
                'accounting.change_paymentschedule',
                'accounting.view_paymentschedulestatus',
                'accounting.change_paymentschedulestatus',
                'accounting.view_bankreceipt',
                'accounting.change_bankreceipt',
                'accounting.view_reconciliationfile',
                'accounting.change_reconciliationfile',
                'accounting.view_reconciliationfilerow',
                'accounting.change_reconciliationfilerow',
                'accounting.view_reconciliation',
                'accounting.change_reconciliation',
                'accounting.view_journalentry',
                'accounting.change_journalentry',
                "distribution.view_category",
                "distribution.view_item",
                "distribution.view_tariff",
                "distribution.change_reasonstatus",
            ]
        },

    ];

    const grouppedPermisison = groupPermissionForMain();

    return (

        <Grid
            container
            alignItems="center"
            justifyContent="flex-start"
            spacing={2}
        >
            <Grid item xs={6}>
                <Typography variant="h3" align="center">Permessi</Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="h3" align="center">Gruppi</Typography>
            </Grid>

            <Grid item xs={6}>
                <TreeView
                    className={classes.root}
                    defaultExpanded={['1']}
                    defaultCollapseIcon={<MinusSquare />}
                    defaultExpandIcon={<PlusSquare />}
                    defaultEndIcon={<CloseSquare />}
                >
                    <StyledTreeItem nodeId="1" label="Permessi">
                        {
                            grouppedPermisison ? grouppedPermisison.map((group: any) => {
                                return (
                                    <StyledTreeItem nodeId={group.group} label={group.group}>
                                        {
                                            group.permissions.map((permission: any) => {
                                                return (
                                                    <StyledTreeItem nodeId={permission} label={permission.title}
                                                        title={permission.message} />
                                                );
                                            })
                                        }
                                    </StyledTreeItem>
                                );
                            }
                            ) : null
                        }
                    </StyledTreeItem>
                </TreeView>
            </Grid>

            <Grid item xs={6}>
                <TreeView
                    className={classes.root}
                    defaultExpanded={['groups']}
                    defaultCollapseIcon={<MinusSquare />}
                    defaultExpandIcon={<PlusSquare />}
                    defaultEndIcon={<CloseSquare />}
                >
                    <StyledTreeItem nodeId={"groups"} label={"Gruppi"}>
                        {
                            groups_info.map((group) => {
                                let groupGrouppedPermisisons = groupPermissionForMainSelected(group.permissions as [string]);
                                return (
                                    <StyledTreeItem nodeId={group.code} label={group.title}>
                                        {
                                            groupGrouppedPermisisons ? groupGrouppedPermisisons.map((group: any) => {
                                                return (
                                                    <StyledTreeItem nodeId={group.group} label={group.group}>
                                                        {
                                                            group.permissions.map((permission: any) => {
                                                                return (
                                                                    <StyledTreeItem nodeId={permission}
                                                                        label={permission.title}
                                                                        title={permission.message} />
                                                                );
                                                            })
                                                        }
                                                    </StyledTreeItem>
                                                );
                                            }
                                            ) : null
                                        }

                                    </StyledTreeItem>
                                );
                            })
                        }
                    </StyledTreeItem>

                </TreeView>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="h3" align="center">Gruppi utenti</Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="h3" align="center">Utenti gruppi</Typography>
            </Grid>
            <Grid item xs={6}>
                <TreeView
                    className={classes.root}
                    defaultExpanded={['groups']}
                    defaultCollapseIcon={<MinusSquare />}
                    defaultExpandIcon={<PlusSquare />}
                    defaultEndIcon={<CloseSquare />}
                >
                    <StyledTreeItem nodeId={"users_groups"} label={"Gruppi utenti"}>
                        {
                            usersGroupped.map((group: any) => {
                                return (
                                    <StyledTreeItem nodeId={group.group} label={getTitoleFromGroupCode(group.group)}>
                                        {
                                            group.users ? group.users.map((user: any) => {
                                                return (
                                                    <StyledTreeItem nodeId={user} label={user} />
                                                );
                                            }
                                            ) : null
                                        }

                                    </StyledTreeItem>
                                );
                            })
                        }
                    </StyledTreeItem>

                </TreeView>
            </Grid>
            <Grid item xs={6}>
                <TreeView
                    className={classes.root}
                    defaultExpanded={['groups']}
                    defaultCollapseIcon={<MinusSquare />}
                    defaultExpandIcon={<PlusSquare />}
                    defaultEndIcon={<CloseSquare />}
                >
                    <StyledTreeItem nodeId={"groups_user"} label={"Utenti gruppi"}>
                        {
                            groupsUser.map((user: any) => {
                                return (
                                    <StyledTreeItem nodeId={user.user} label={user.user}>
                                        {
                                            user.groups ? user.groups.map((group: any) => {
                                                return (
                                                    <StyledTreeItem nodeId={group}
                                                        label={getTitoleFromGroupCode(group)} />
                                                );
                                            }
                                            ) : null
                                        }

                                    </StyledTreeItem>
                                );
                            })
                        }
                    </StyledTreeItem>

                </TreeView>
            </Grid>
        </Grid>


    );
};

